import {QueryConfig} from "react-query";
import {network, users as typesUsers} from "../../../../../types";
import useQueryHookWrapper from "../../../../../hooks/use-query-hook-wrapper";
import {servicesUsers} from "../../../../../services";

const useUsersEkycDetailGet = (
    id: string,
    arg0?: QueryConfig<
        network.TQueryDefWrapper<typesUsers.IGetEKYCDetailsResponse>,
        string
    >,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<typesUsers.IGetEKYCDetailsResponse>,
        string,
        string
    >({
        queryKey: `e_kyc_get_${id}`,
        queryFn: servicesUsers.getEkyDetailByUserId,
        queryConfig: arg0,
        values: id,
    });
};

export default useUsersEkycDetailGet;
